"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _services = require("../../services");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledGridColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n"])));
var UpsellSectionRow = function UpsellSectionRow() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      sm: 3
    },
    layout: {
      sm: [6, 3, 3]
    },
    spacing: 3
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2
  }, _services.locale.localeString('RelationshipOffer.Items')), /*#__PURE__*/_react.default.createElement(StyledGridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2
  }, _services.locale.localeString('RelationshipOffer.Upfront'))), /*#__PURE__*/_react.default.createElement(StyledGridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2
  }, _services.locale.localeString('RelationshipOffer.Monthly')))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null))));
};
var _default = UpsellSectionRow;
exports.default = _default;